import {useEffect, useCallback} from 'react'
import {useDispatch} from 'redux-react-hook'
import ApiSdk from 'services/callApi'
import {entities as entitiesAct} from 'actions'

export default function useGetUserAssetProvider () {
  const dispatch = useDispatch()
  const fetchData = useCallback(async () => {
    const res = await ApiSdk.futures.getMaxWithdrawAmount()
    const maxWithdrawAmount = Math.max(res?.hasOwnProperty('error') ? 0 : res, 0)
    dispatch(entitiesAct({maxWithdrawAmount}))
  }, [dispatch])

  useEffect(() => {
    fetchData()
  }, [dispatch, fetchData])
}
